/* NewBorn Times : feuilletage du journal, bloc produit et formulaire de commande */
(function () {
  function initFlip(root) {
    if (root.dataset.nbtReady) return;
    root.dataset.nbtReady = '1';
    var pages = root.querySelectorAll('[data-nbt-page]');
    var dots = root.querySelectorAll('[data-nbt-dot]');
    var prev = root.querySelector('[data-nbt-prev]');
    var next = root.querySelector('[data-nbt-next]');
    var stage = root.querySelector('[data-nbt-stage]');
    var i = Math.min(parseInt(root.dataset.start || '0', 10) || 0, pages.length - 1);
    function show(k) {
      if (!pages.length) return;
      i = Math.max(0, Math.min(pages.length - 1, k));
      pages.forEach(function (p, n) { p.hidden = n !== i; });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === pages.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (stage) stage.addEventListener('click', function () { show(i + 1 > pages.length - 1 ? 0 : i + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
    show(i);
  }

  function initProduct(root) {
    if (root.dataset.nbtGalleryReady) return;
    root.dataset.nbtGalleryReady = '1';
    var stage = root.querySelector('[data-nbt-gallery-stage]');
    var main = root.querySelector('[data-nbt-gallery-main]');
    var thumbs = root.querySelectorAll('[data-nbt-thumb]');
    var cta = root.querySelector('[data-nbt-cta-price]');
    var currentCover = main ? main.getAttribute('src') : '';

    var pvEl = root.querySelector('[data-nbt-pv]');
    var note = root.querySelector('[data-nbt-gallery-note]');
    function setMain(src, srcset, isPhoto, alt) {
      if (pvEl && main) {
        // Bloc commande de l'accueil : la vignette couverture montre l'apercu vivant, les autres une photo
        pvEl.hidden = !!isPhoto; main.hidden = !isPhoto;
        if (note) note.hidden = !!isPhoto;
        if (stage) stage.classList.toggle('is-photo', !!isPhoto);
        if (isPhoto && src) {
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
          main.setAttribute('alt', alt || '');
        }
        return;
      }
      if (!main || !src) return;
      main.setAttribute('src', src);
      if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
      if (alt != null) main.setAttribute('alt', alt);
      if (stage) stage.classList.toggle('is-photo', !!isPhoto);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var isCover = t.dataset.kind === 'cover';
        setMain(isCover ? currentCover : t.dataset.src, isCover ? '' : t.dataset.srcset, !isCover, t.dataset.alt);
      });
    });
    root.querySelectorAll('[data-nbt-edition]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked || !r.dataset.src) return;
        currentCover = r.dataset.src;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.kind === 'cover'); });
        var coverThumb = root.querySelector('[data-nbt-thumb][data-kind="cover"] img');
        if (coverThumb) { coverThumb.setAttribute('src', r.dataset.src); coverThumb.removeAttribute('srcset'); }
        setMain(r.dataset.src, '', false, r.dataset.alt);
      });
    });
    root.querySelectorAll('[data-nbt-format]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked && cta) cta.textContent = r.dataset.price || '';
      });
    });
    var form = root.querySelector('[data-nbt-form]');
    if (pvEl && form) {
      // Des que l'on repond, revenir a l'apercu de la couverture, a l'edition choisie
      var showCover = function () {
        var ed = form.querySelector('input[name="nbt-edition"]:checked');
        var key = ['rose', 'bleue', 'lin'][ed ? +ed.getAttribute('data-idx') : 0] || 'rose';
        var pvCover = root.querySelector('[data-nbt-pv-cover]');
        var coverThumb = root.querySelector('[data-nbt-thumb][data-kind="cover"] img');
        if (pvCover && coverThumb && pvCover.dataset[key]) { coverThumb.setAttribute('src', pvCover.dataset[key]); coverThumb.removeAttribute('srcset'); }
        if (!pvEl.hidden) return;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.kind === 'cover'); });
        setMain('', '', false, null);
      };
      form.addEventListener('input', showCover);
      form.addEventListener('change', showCover);
    }
  }


  function initOrder(root) {
    if (root.dataset.nbtReady) return;
    root.dataset.nbtReady = '1';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-nbt-variants]').textContent); } catch (e) {}
    var form = root.querySelector('[data-nbt-form]');
    var idInput = root.querySelector('[data-nbt-variant-id]');
    var priceEls = root.querySelectorAll('[data-nbt-price], [data-nbt-cta-price]');
    var copyBox = root.querySelector('[data-nbt-copy]');
    var copyRow = root.querySelector('[data-nbt-copy-row]');
    var boxBox = root.querySelector('[data-nbt-box]');
    var boxRow = root.querySelector('[data-nbt-box-row]');
    var LANG = root.getAttribute('data-nbt-lang') || 'fr', LOC = LANG === 'en' ? 'en-US' : 'fr-FR';
    var money = new Intl.NumberFormat(LOC, { style: 'currency', currency: root.getAttribute('data-nbt-currency') || 'EUR', minimumFractionDigits: 0 });
    var exv = [];
    try { exv = JSON.parse(root.querySelector('[data-nbt-ex]').textContent) || []; } catch (e) {}
    var X_NONE = exv[0] || 'Aucun', X_COPY = exv[1] || '2e exemplaire', X_BOX = exv[2] || 'Boîte à souvenirs', X_BOTH = exv[3] || '2e exemplaire + boîte';
    var pv = root.querySelector('[data-nbt-pv]');
    var q = function (sel) { return root.querySelector(sel); };
    function val(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : ''; }
    function groupVal(g) { var el = form.querySelector('[data-nbt-toggle="' + g + '"]:checked'); return el ? el.value : ''; }

    function updateVariant() {
      var f = val('nbt-format'), ed = val('nbt-edition');
      // Lancement US : ni deuxième exemplaire ni boîte ne sont fabriqués ou expédiés.
      var hasCopy = false;
      var hasBox = false;
      if (copyRow) copyRow.hidden = !hasCopy;
      if (boxRow) boxRow.hidden = !hasBox;
      var addonsLabel = q('[data-nbt-addons-label]');
      if (addonsLabel) addonsLabel.hidden = !hasCopy && !hasBox;
      var c = hasCopy && copyBox && copyBox.checked, b = hasBox && boxBox && boxBox.checked;
      var ex = c && b ? X_BOTH : (c ? X_COPY : (b ? X_BOX : X_NONE));
      var v = variants.filter(function (x) { return x.option1 === f && x.option2 === ed && (!x.option3 || x.option3 === ex); })[0];
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money.format(v.price / 100); });
    }

    function updateConds() {
      root.querySelectorAll('[data-nbt-cond]').forEach(function (box) {
        var parts = box.getAttribute('data-nbt-cond').split(':');
        var on = groupVal(parts[0]) === parts.slice(1).join(':');
        box.hidden = !on;
        box.querySelectorAll('input, select, textarea').forEach(function (inp) {
          inp.disabled = !on;
          if (inp.hasAttribute('data-nbt-req')) inp.required = on;
        });
      });
    }

    var photoURL = '';
    function fitName(el, box) {
      el.style.fontSize = '';
      var max = box.clientWidth * 0.9;
      if (el.scrollWidth > max && el.scrollWidth > 0) el.style.fontSize = (19 * max / el.scrollWidth) + 'cqw';
    }
    function updatePreview() {
      if (!pv) return;
      var edEl = form.querySelector('input[name="nbt-edition"]:checked');
      var cover = q('[data-nbt-pv-cover]');
      var key = ['rose', 'bleue', 'lin'][edEl ? +edEl.getAttribute('data-idx') : 0] || 'rose';
      if (cover && cover.dataset[key] && cover.getAttribute('src') !== cover.dataset[key]) cover.setAttribute('src', cover.dataset[key]);
      pv.style.setProperty('--nbt-st', key === 'bleue' ? '#D7E2F3' : (key === 'lin' ? '#E6DCCB' : '#F2D3DB'));

      var first = (q('[data-nbt-first]').value || '').trim();
      var sexEl = form.querySelector('[data-nbt-sex]:checked');
      var sex = sexEl ? sexEl.getAttribute('data-sex') : '';
      var namePatch = q('[data-nbt-pv-name]');
      var nameOn = first !== '' || sex !== '';
      namePatch.classList.toggle('is-on', nameOn);
      if (nameOn) {
        var shown = first || (LANG === 'en' ? (sex === 'boy' ? 'Leo' : 'Olivia') : (key === 'bleue' ? 'Adam' : 'Estelle'));
        var firstEl = namePatch.querySelector('.nbt-pv__first');
        firstEl.textContent = shown;
        var girl = sex ? sex === 'girl' : key !== 'bleue';
        namePatch.querySelector('.nbt-pv__nee').textContent = LANG === 'en' ? 'is born' : (girl ? 'est née' : 'est né');
        fitName(firstEl, namePatch);
      }

      var city = (q('[data-nbt-city]').value || '').trim(), country = (q('[data-nbt-country]').value || '').trim();
      var placeOn = city !== '' || country !== '';
      var place = q('[data-nbt-pv-place]');
      place.classList.toggle('is-on', placeOn);
      if (placeOn) place.querySelector('span').textContent = (city || (LANG === 'en' ? 'New York' : 'Paris')) + ' ✦ ' + (country || (LANG === 'en' ? 'United States' : 'France'));

      var dRaw = q('[data-nbt-date]').value, dObj = dRaw ? new Date(dRaw + 'T12:00:00') : null;
      var dateEl = q('[data-nbt-pv-date]');
      dateEl.classList.toggle('is-on', !!dObj);
      if (dObj) dateEl.querySelector('span').textContent = new Intl.DateTimeFormat(LOC, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(dObj);

      var mode = (form.querySelector('[data-nbt-photo-mode]:checked') || {}).getAttribute ? form.querySelector('[data-nbt-photo-mode]:checked').getAttribute('data-nbt-photo-mode') : '';
      var photoBox = q('[data-nbt-pv-photo]'), photoImg = q('[data-nbt-pv-photo-img]'), later = q('[data-nbt-pv-later]'), stork = q('[data-nbt-pv-stork]');
      var photoOn = (mode === 'now' && photoURL) || mode === 'later';
      photoBox.classList.toggle('is-on', !!photoOn);
      if (photoImg) { photoImg.hidden = !(mode === 'now' && photoURL); if (photoURL) photoImg.src = photoURL; }
      if (later) later.hidden = mode !== 'later';
      if (stork) stork.hidden = mode !== 'stork';
      // Couverture vitrine (25/10/2026, visiteur anglais) : au repos, l'exemple d'Olivia avec sa photo ; dès la première
      // réponse elle s'efface et laisse la couverture à remplir (prénom posé, cigogne dans le cadre) ; tout effacé, elle revient
      var vitrine = q('[data-nbt-pv-vitrine]');
      var repondu = !!(first || sex || dRaw || city || (mode && mode !== '') || key !== 'rose');
      if (vitrine) vitrine.classList.toggle('is-off', repondu);

      var sticker = q('[data-nbt-pv-sticker]');
      var stickerOn = placeOn || !!dObj || !!photoOn || mode === 'stork';
      sticker.classList.toggle('is-on', stickerOn);
      if (stickerOn) {
        var dd = dObj ? (LANG === 'en' ? ((dObj.getMonth() + 1) + '.' + String(dObj.getDate()).padStart(2, '0') + '.' + dObj.getFullYear()) : (dObj.getDate() + '.' + String(dObj.getMonth() + 1).padStart(2, '0') + '.' + dObj.getFullYear())) : (LANG === 'en' ? '9.28.2026' : '7.07.2026');
        q('[data-nbt-pv-st-line]').textContent = (city || (LANG === 'en' ? 'New York' : 'Paris')) + ' · ' + dd;
      }
    }

    // Date de naissance : le client voit « 3 octobre 2026 » dans le panier, la fabrication garde 2026-10-03
    var dateInput = q('[data-nbt-date]');
    if (dateInput && dateInput.name) {
      var dateShown = document.createElement('input'), dateIso = document.createElement('input');
      dateShown.type = dateIso.type = 'hidden';
      dateShown.name = dateInput.name; dateIso.name = 'properties[_date_iso]';
      dateInput.removeAttribute('name');
      form.appendChild(dateShown); form.appendChild(dateIso);
      var syncDate = function () {
        var v = dateInput.value;
        dateIso.value = v;
        dateShown.value = v ? new Intl.DateTimeFormat(LOC, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(v + 'T12:00:00')) : '';
      };
      dateInput.addEventListener('input', syncDate);
      dateInput.addEventListener('change', syncDate);
      syncDate();
    }

    var fileInput = q('[data-nbt-file]');
    if (fileInput) fileInput.addEventListener('change', function () {
      if (photoURL) URL.revokeObjectURL(photoURL);
      photoURL = fileInput.files && fileInput.files[0] ? URL.createObjectURL(fileInput.files[0]) : '';
      updatePreview();
    });
    form.addEventListener('input', function () { updatePreview(); });
    form.addEventListener('change', function () { updateVariant(); updateConds(); updatePreview(); });
    window.addEventListener('resize', updatePreview);
    // Lien du coupon « Un deuxième exemplaire » (accueil) : ?exemplaires=2 coche le second exemplaire
    if (false && copyBox && /[?&]exemplaires=2(&|$)/.test(window.location.search)) {
      var two = variants.filter(function (v) { return v.option3 === X_COPY; })[0];
      if (two) {
        form.querySelectorAll('input[name="nbt-format"]').forEach(function (r) { if (r.value === two.option1) r.checked = true; });
        copyBox.checked = true;
      }
    }
    // Accueil : les autres questions s'ouvrent des les deux premieres reponses (prenom, puis date ou ville)
    var more = q('[data-nbt-more]');
    var moreHint = q('[data-nbt-more-hint]');
    function reveal() {
      if (!more || !more.hidden) return;
      more.hidden = false;
      more.classList.add('is-opening');
      if (moreHint) moreHint.hidden = true;
    }
    function filledVal(sel) { var el = q(sel); return !!(el && el.value && el.value.trim() !== ''); }
    function checkReveal() {
      if (!more || !more.hidden) return;
      if (filledVal('[data-nbt-first]') && (filledVal('[data-nbt-date]') || filledVal('[data-nbt-city]'))) reveal();
    }
    if (more) {
      form.addEventListener('input', checkReveal);
      form.addEventListener('change', checkReveal);
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.addEventListener('click', function (e) {
        if (!more.hidden) return;
        e.preventDefault();
        reveal();
        setTimeout(function () { form.reportValidity(); }, 60);
      });
    }
    updateVariant(); updateConds(); updatePreview(); checkReveal();
  }

  function initPageFlip(root) {
    if (root.dataset.nbtReady) return;
    var book = root.querySelector('[data-nbt-book]');
    if (!book) return;
    var prev = root.querySelector('[data-nbt-prev]'), next = root.querySelector('[data-nbt-next]'), count = root.querySelector('[data-nbt-count]');
    function start() {
      if (root.dataset.nbtReady) return true;
      if (!window.St || !window.St.PageFlip) return false;
      root.dataset.nbtReady = '1';
      var pf = new window.St.PageFlip(book, {
        width: 394, height: 566, size: 'stretch', minWidth: 200, maxWidth: 520, minHeight: 287, maxHeight: 747,
        maxShadowOpacity: 0.5, drawShadow: true, showCover: true, mobileScrollSupport: false, usePortrait: true, flippingTime: 900
      });
      var pageEls = book.querySelectorAll('.nbt-page');
      pf.loadFromHTML(pageEls);
      root._nbtPf = pf;
      // Les images des pages lointaines (data-nbt-bg) ne se chargent qu'a l'approche, pour alleger le telephone
      function loadAround(i) {
        for (var j = Math.max(0, i - 2); j <= Math.min(pageEls.length - 1, i + 7); j++) {
          var img = pageEls[j].querySelector('[data-nbt-bg]');
          if (img) { img.style.backgroundImage = "url('" + img.getAttribute('data-nbt-bg') + "')"; img.removeAttribute('data-nbt-bg'); }
        }
      }
      loadAround(0);
      function upd() {
        var i = pf.getCurrentPageIndex(), n = pf.getPageCount();
        loadAround(i);
        if (count) count.textContent = (i + 1) + ' / ' + n;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= n - 1;
      }
      if (prev) prev.addEventListener('click', function () { pf.flipPrev(); });
      if (next) next.addEventListener('click', function () { pf.flipNext(); });
      pf.on('flip', upd);
      upd();
      return true;
    }
    if (!start()) {
      var tries = 0;
      var t = setInterval(function () { if (start() || ++tries > 60) clearInterval(t); }, 250);
    }
  }

  function initCookies(root) {
    if (root.dataset.nbtReady) return;
    root.dataset.nbtReady = '1';
    var prefs = root.querySelector('[data-nbt-cookies-prefs]');
    var save = root.querySelector('[data-nbt-cookies-save]');
    var api = null;
    function boxes() { return root.querySelectorAll('[data-nbt-consent]'); }
    function open(withPrefs) {
      root.hidden = false;
      if (withPrefs) { prefs.hidden = false; save.hidden = false; }
    }
    function close() { root.hidden = true; prefs.hidden = true; save.hidden = true; }
    function apply(choice) {
      try { localStorage.setItem('nbt-consent', JSON.stringify(choice)); } catch (e) {}
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({ analytics: choice.analytics, marketing: choice.marketing, preferences: choice.preferences }, function () {});
      }
      close();
    }
    function fill(c) {
      boxes().forEach(function (b) { b.checked = !!c[b.getAttribute('data-nbt-consent')]; });
    }
    root.querySelector('[data-nbt-cookies-accept]').addEventListener('click', function () { apply({ analytics: true, marketing: true, preferences: true }); });
    root.querySelector('[data-nbt-cookies-refuse]').addEventListener('click', function () { apply({ analytics: false, marketing: false, preferences: false }); });
    root.querySelector('[data-nbt-cookies-custom]').addEventListener('click', function () { prefs.hidden = !prefs.hidden; save.hidden = prefs.hidden; });
    save.addEventListener('click', function () {
      var c = {}; boxes().forEach(function (b) { c[b.getAttribute('data-nbt-consent')] = b.checked; }); apply(c);
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-nbt-cookies-open]');
      if (!t) return;
      e.preventDefault();
      var c = {};
      if (api && api.currentVisitorConsent) {
        var v = api.currentVisitorConsent();
        c = { analytics: v.analytics === 'yes', marketing: v.marketing === 'yes', preferences: v.preferences === 'yes' };
      } else { try { c = JSON.parse(localStorage.getItem('nbt-consent') || '{}'); } catch (err) {} }
      fill(c); open(true);
    });
    function decide() {
      var undecided = true;
      if (api && api.currentVisitorConsent) {
        var v = api.currentVisitorConsent();
        undecided = v.analytics === '' && v.marketing === '' && v.preferences === '';
      } else { try { undecided = !localStorage.getItem('nbt-consent'); } catch (e) {} }
      if (undecided || root.hasAttribute('data-nbt-cookies-preview')) open(false);
    }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) api = window.Shopify.customerPrivacy;
        decide();
      });
    } else { decide(); }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nbt-flip]').forEach(initFlip);
    (scope || document).querySelectorAll('[data-nbt-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-nbt-order]').forEach(initOrder);
    (scope || document).querySelectorAll('[data-nbt-cookies]').forEach(initCookies);
    (scope || document).querySelectorAll('[data-nbt-pageflip]').forEach(initPageFlip);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { var c = e.target.querySelector && e.target.querySelector('[data-nbt-cookies]'); if (c) c.hidden = false; });
})();
